export const buildArticleSchema = ({
    url,
    title,
    description,
    image,
    publishedAt,
    updatedAt,
}) => {
    return {
        "@context": "https://schema.org",
        "@type": "Article",
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url,
        },
        headline: title,
        description: description,
        image: Array.isArray(image) ? image : [image],
        author: {
            "@type": "Person",
            name: "Find My Venue",
        },
        publisher: {
            "@type": "Organization",
            name: "Find My Venue",
            logo: {
                "@type": "ImageObject",
                url: "https://www.findmyvenue.com/static/media/whitelogo.67bf39d2442f25423feef91abf2d9d6.svg",
            },
        },
        datePublished: new Date(publishedAt).toISOString(),
        dateModified: new Date(updatedAt || publishedAt).toISOString(),
    };
};